import { graphql, useStaticQuery } from "gatsby"

export default function useDataPolicy() {
  const query = useStaticQuery(graphql`
      query GET_DATA_POLICY {
          allContentfulNolRegistro {
              nodes {
                  node_locale
                  politicaDeDatos {
                      raw
                  }
                  checksLegales {
                      tituloPrincipal
                      redireccion
                      idPrincipal

                  }
              }
          }
      }
  `)

  const data = query.allContentfulNolRegistro.nodes.filter(e => e.node_locale === process.env.LOCALE)[0]


  return {
    dataPolicy: data.politicaDeDatos,
    checksPolicy: data.checksLegales,
  }
}
